// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Box, Paper, Typography, styled } from '@mui/material';
import { ForwardedRef, PropsWithChildren, forwardRef } from 'react';

const Container = styled(Paper)({
  display: 'flex',
  overflow: 'hidden',
  flexDirection: 'column',
});

interface Props {
  title: string;
}

function ReportCardRenderer(
  props: PropsWithChildren<Props>,
  ref: ForwardedRef<HTMLDivElement>
) {
  return (
    <Container ref={ref} variant="outlined">
      <Typography variant="subtitle1" marginX={2} marginY={1}>
        {props.title}
      </Typography>
      <Box flex={1} position="relative">
        {props.children}
      </Box>
    </Container>
  );
}

export const ReportCard = forwardRef(ReportCardRenderer);
